import { useState } from "react";
import { useSpeakingParticipants } from "@livekit/components-react";

/**
 * Who the room is listening to.
 *
 * The identity of the last person other than you to speak — last, not
 * currently: LiveKit reports an empty set of speakers during every pause in a
 * sentence, and a stage that changed hands on each of those would be a stage
 * nobody could watch. A couple session is one conversation, not a slideshow.
 *
 * Yourself excluded. You are the one participant in the call who does not
 * need to be shown their own face for talking, and in a two-person session
 * following your own voice would swap the picture every time you answered.
 */
export function useActiveSpeaker(): string | null {
    const speaking = useSpeakingParticipants();
    const [identity, setIdentity] = useState<string | null>(null);

    // Sorted loudest first by the room, so the first one that is not you is
    // the person being listened to.
    const loudest =
        speaking.find((participant) => !participant.isLocal)?.identity ?? null;

    // Adjusted during the render that notices rather than in an effect, so
    // the picture never shows a frame of the speaker who has just finished.
    if (loudest !== null && loudest !== identity) setIdentity(loudest);

    return identity;
}
